// extracted by mini-css-extract-plugin
export default {"wrapper":"order-row_wrapper__PC0z9","desc_block":"order-row_desc_block__T2hSp","price_block":"order-row_price_block__1eIP2","img":"order-row_img__G61fl"};